import { registerPlugin } from '@capacitor/core';
const NativePicker = registerPlugin('NativePicker', {
    web: () => import('./web').then(m => new m.NativePickerWeb()),
});
export * from './definitions';
export { NativePicker };
//# sourceMappingURL=index.js.map